import { createRoot } from "react-dom/client";
import AuthScreen from "@app/components/AuthScreen";
import { App } from "@app/components/App";
import { AppContext } from "./contexts/AppContext";
import { useAuth } from "./contexts/AuthContext";
import { useMatch } from "react-router-dom";

function Root() {
  return (
    <AppContext>
      <Prelude />
    </AppContext>
  );
}

const Prelude = () => {
  const { state } = useAuth();
  const isLogin = !!useMatch("/login");

  if (state === "loading")
    return (
      <div className="flex h-dvh items-center justify-center text-sm text-ink-muted">
        Loading…
      </div>
    );

  if (isLogin) return <AuthScreen />;

  return <App />;
};

createRoot(document.getElementById("app")!).render(<Root />);
